import TreeSelect, { TreeSelectProps } from "@/shared/form/tree-select";
import { toTree } from "@/modules/common/entities/company-structure/select/utils/to-tree/to-tree";
import { useTranslations } from "use-intl";
import { HierarchyElementType } from "gql/graphql";
import {
  TreeNodeWithValue,
  useTreeExpandedKeys,
} from "@/modules/common/entities/company-structure/select/utils/use-tree-expanded-keys";
import { useCompanyStructureData } from "@/modules/common/entities/company-structure/select/model/use-company-structure-data";

type CompanyStructureSelectProps = TreeSelectProps & {
  types?: HierarchyElementType[];
  autoExpandOnMount?: boolean;
  disabledTypes?: string[];
  fromNodeId?: string;
};

export function CompanyStructureSelect({
  types = [HierarchyElementType.Organization],
  value,
  autoExpandOnMount = true,
  disabledTypes,
  // pass if you want to show only subtree of company structure
  fromNodeId,
  ...rest
}: CompanyStructureSelectProps) {
  const t = useTranslations("CompanyStructureSelect");
  const { nodes, loading } = useCompanyStructureData({
    fromNodeId,
    types,
  });

  const treeData = toTree(
    nodes,
    disabledTypes,
    fromNodeId,
  ) as TreeNodeWithValue[];

  const { expandedKeys, setExpandedKeys } = useTreeExpandedKeys({
    treeData,
    value,
    loading,
    autoExpandOnMount,
  });

  return (
    <TreeSelect
      placeholder={t("Select a department")}
      showSearch
      allowClear
      loading={loading}
      treeData={treeData}
      value={loading ? undefined : value}
      treeDefaultExpandAll={false}
      treeExpandedKeys={expandedKeys}
      onTreeExpand={(keys) => setExpandedKeys(keys.map(String))}
      filterTreeNode={(search, node) =>
        String(node.label).toLowerCase().includes(search.toLowerCase())
      }
      {...rest}
    />
  );
}
